export default __webpack_public_path__ + "53595f7e50cce120a6c0ad42c9709e25.svg";